export enum LayoutActionTypes {
  SET_LAYOUT_SIDEBAR_IS_OPEN = '@set/sidebar/isOpen',
  TOGGLE_LAYOUT_SIDEBAR_IS_OPEN = '@toggle/sidebar/isOpen',
}
